import { render, staticRenderFns } from "./GroupSessionTypeCrud.vue?vue&type=template&id=4421b612&"
import script from "./GroupSessionTypeCrud.vue?vue&type=script&lang=js&"
export * from "./GroupSessionTypeCrud.vue?vue&type=script&lang=js&"
import style0 from "./GroupSessionTypeCrud.vue?vue&type=style&index=0&id=4421b612&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports